<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="submit" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isVisible" :vm-title='$t("strings.change_status")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("strings.status_placeholder")' :danger="$v.form.status.$invalid && $v.form.status.$model" :danger-text="$t('validation.required', { attribute: $t('strings.status') })" v-model="form.status" :label='$t("strings.status")' :default-value="statuses[(form.status-1)].text")
            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in statuses")
</template>
<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')

export default {
  name: 'ModalChangeStatus',
  mixins: [ModalMixin1],
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    form: {
      status: 1,
      finish_date: moment().subtract(1, 'days')
    },
    statuses: [
      {
        value: 1,
        text: 'Activo'
      },
      {
        value: 2,
        text: 'Finalizado'
      }
    ]
  }),
  validations () {
    return {
      form: {
        status: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'isModalChangeStatusVisible'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'setModalChangeStatus',
      'changeStatus'
    ]),
    close () {
      this.$emit('closeModal')
    },
    submit () {
      this.$emit('submit', this.form)
      this.close()
    }
  }
}
</script>
<style lang="scss">
.image_section {
  padding-left: 0.5rem;
  -webkit-box-shadow: inset -33px -33px 3px -30px rgba(3,52,4,0.06);
  box-shadow: inset -33px -33px 3px -30px rgba(3,52,4,0.06);
}
.image_indicator {
  margin: 1rem 0 0 76%;
  text-align: center;
  padding: .4rem;
  width: 2rem;
  height: 2rem;
  border-top: 1px solid rgba(var(--primary),1);
  border-right: 1px solid rgba(var(--primary),1);
  border-bottom: 1px solid rgba(var(--primary),1);
  border-left: 1px solid rgba(var(--primary),1);
  border-radius: 100%;
}
.images_container {
  padding-left: 1.3rem;
}
</style>
